var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTournaments = function SvgTournaments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.026 2.995A.96.96 0 0 1 7 2h10a.96.96 0 0 1 .974.995c-.022.518-.061 1.21-.134 2.005H21a.5.5 0 0 1 .5.5 7.01 7.01 0 0 1-5.24 6.78c-.734 1.75-1.777 3.146-3.26 3.58v4.22c1.64.275 2.492 1.187 2.827 1.648.087.12-.002.272-.15.272H8.323c-.15 0-.238-.151-.15-.272.334-.46 1.185-1.373 2.826-1.648v-4.22c-1.483-.434-2.526-1.83-3.26-3.58A7.01 7.01 0 0 1 2.5 5.5.5.5 0 0 1 3 5h3.16a41 41 0 0 1-.134-2.005M6.264 6H3.52a6.01 6.01 0 0 0 3.78 5.088C6.764 9.423 6.45 7.585 6.264 6m10.435 5.088c.537-1.665.852-3.503 1.037-5.088h2.743a6.01 6.01 0 0 1-3.78 5.088",
    clipRule: "evenodd"
  })));
};
export default SvgTournaments;